import { render, staticRenderFns } from "./OrganizationModuleSettingForm.vue?vue&type=template&id=3b08682e&scoped=true"
import script from "./OrganizationModuleSettingForm.vue?vue&type=script&lang=js"
export * from "./OrganizationModuleSettingForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizationModuleSettingForm.vue?vue&type=style&index=0&id=3b08682e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08682e",
  null
  
)

export default component.exports